import { RoadDetailInfo as L2RSegmentDetailInfo } from "@l2r-front/l2r-networks"
import { BottomSheetContent as UiBottomSheetContent, styled } from "@l2r-front/l2r-ui"

export const Container = styled("div")(() => ({
    display: "flex",
    flexDirection: "column",
}))

export const RoadDetailInfo = styled(L2RSegmentDetailInfo)(({ theme }) => ({
    marginBottom: theme.spacing(6),
}))

export const BottomSheetContent = styled(UiBottomSheetContent)(({ theme }) => ({
    padding: theme.spacing(0, 6, 0, 6),
}))